/** @jsxImportSource @emotion/react */

import { css, keyframes } from "@emotion/react";
import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import { MissionSpecCard } from "models/MissionSpec";
import { FC } from "react";
import MissionCard from "views/HomeV2/MissionCard";
import { sortMissions } from "views/HomeV2/utils";

const fadeInTranslate = keyframes`
  from {
    transform: translateX(-100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

interface CardListProps {
  cards: MissionSpecCard[];
}

const getCSSRules: CSSRulesResolver = () => ({
  card: {
    opacity: 0,
    animation: `${fadeInTranslate} 0.5s ease forwards`,
  },
});

const CardList: FC<CardListProps> = ({ cards = [] }) => {
  const styles = useCSSRulesWithTheme(getCSSRules);

  return (
    <>
      {cards.length > 0 &&
        cards.sort(sortMissions).map((card, idx) => (
          <div
            key={card.mid}
            css={css(styles.card, { animationDelay: `${idx * 0.15}s` })}
          >
            <MissionCard mission={card} />
          </div>
        ))}
    </>
  );
};

export default CardList;
